import SimpleDetailsSection, { SimpleDetailsSectionProps } from './SimpleDetailsSection';

export type { SimpleDetailsSectionProps };
export default SimpleDetailsSection;
